import { FC } from 'react'

import TrainingGroupFormFields from './training-group-form-fields'

import { ITrainingGroupFormProps } from './training-group-form-types'

const TrainingGroupForm: FC<ITrainingGroupFormProps> = props => {
  const { handleSubmit, formName, submitting } = props

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <TrainingGroupFormFields disabled={submitting} />
    </form>
  )
}

export default TrainingGroupForm
